/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R404RouteImport } from './routes/404'
import { Route as BookCreationRouteImport } from './routes/book-creation'
import { Route as BookSetupRouteImport } from './routes/book-setup'
import { Route as StartMigrationRouteImport } from './routes/start-migration'
import { Route as UnsupportedBrowserRouteImport } from './routes/unsupported-browser'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const BookCreationRoute = BookCreationRouteImport.update({
  id: '/book-creation',
  path: '/book-creation',
  getParentRoute: () => rootRouteImport,
} as any)
const BookSetupRoute = BookSetupRouteImport.update({
  id: '/book-setup',
  path: '/book-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const StartMigrationRoute = StartMigrationRouteImport.update({
  id: '/start-migration',
  path: '/start-migration',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsupportedBrowserRoute = UnsupportedBrowserRouteImport.update({
  id: '/unsupported-browser',
  path: '/unsupported-browser',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/book-creation': typeof BookCreationRoute
  '/book-setup': typeof BookSetupRoute
  '/start-migration': typeof StartMigrationRoute
  '/unsupported-browser': typeof UnsupportedBrowserRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/book-creation': typeof BookCreationRoute
  '/book-setup': typeof BookSetupRoute
  '/start-migration': typeof StartMigrationRoute
  '/unsupported-browser': typeof UnsupportedBrowserRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/book-creation': typeof BookCreationRoute
  '/book-setup': typeof BookSetupRoute
  '/start-migration': typeof StartMigrationRoute
  '/unsupported-browser': typeof UnsupportedBrowserRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/book-creation'
    | '/book-setup'
    | '/start-migration'
    | '/unsupported-browser'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/book-creation'
    | '/book-setup'
    | '/start-migration'
    | '/unsupported-browser'
  id:
    | '__root__'
    | '/'
    | '/404'
    | '/book-creation'
    | '/book-setup'
    | '/start-migration'
    | '/unsupported-browser'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  BookCreationRoute: typeof BookCreationRoute
  BookSetupRoute: typeof BookSetupRoute
  StartMigrationRoute: typeof StartMigrationRoute
  UnsupportedBrowserRoute: typeof UnsupportedBrowserRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book-creation': {
      id: '/book-creation'
      path: '/book-creation'
      fullPath: '/book-creation'
      preLoaderRoute: typeof BookCreationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book-setup': {
      id: '/book-setup'
      path: '/book-setup'
      fullPath: '/book-setup'
      preLoaderRoute: typeof BookSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start-migration': {
      id: '/start-migration'
      path: '/start-migration'
      fullPath: '/start-migration'
      preLoaderRoute: typeof StartMigrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsupported-browser': {
      id: '/unsupported-browser'
      path: '/unsupported-browser'
      fullPath: '/unsupported-browser'
      preLoaderRoute: typeof UnsupportedBrowserRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  BookCreationRoute: BookCreationRoute,
  BookSetupRoute: BookSetupRoute,
  StartMigrationRoute: StartMigrationRoute,
  UnsupportedBrowserRoute: UnsupportedBrowserRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
